import { Button, Flex, Paper, Stack, Text } from '@mantine/core';
import { useSuspenseQuery } from '@tanstack/react-query';
import { Suspense, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { CenterReportCriteriaGathering } from '@/module/Laboratory/CenterReportCriteriaGathering';
import { getCenterLastReportTemplateOptions } from '@/module/ResearchCenter';

import { PendingSpinner } from '@/core/components';

import { Id } from '@feature/utils';

export function CenterReportGathering({ labId }: { labId: Id }) {
  const { data: template } = useSuspenseQuery(getCenterLastReportTemplateOptions());
  const [index, setIndex] = useState(0);
  const { t } = useTranslation();

  const currentCriteriaTemplate = template.criteria[index];
  const next = () => setIndex(val => val + 1);
  const prev = () => setIndex(val => val - 1);

  return (
    <Stack>
      <Paper p="sm">
        <Flex
          align="center"
          justify="space-between"
        >
          <Button
            miw="70px"
            size="xs"
            onClick={prev}
            disabled={index === 0}
          >
            {t('centerReport.previous')}
          </Button>
          <Text
            px="7px"
            fw="500"
            size="lg"
          >
            {currentCriteriaTemplate.name}
          </Text>
          <Button
            miw="90px"
            size="xs"
            onClick={next}
            disabled={index == template.criteria.length - 1}
          >
            {t('centerReport.next')}
          </Button>
        </Flex>
      </Paper>
      <Suspense fallback={<PendingSpinner h="300px" />}>
        <CenterReportCriteriaGathering
          key={`${labId}-${currentCriteriaTemplate.criteriaCode}`}
          labId={labId}
          criteria={currentCriteriaTemplate}
        />
      </Suspense>
    </Stack>
  );
}
